import { z } from "zod"

/** Badge counts: items with activity the viewer has not opened (NOTASK-1). */
export const activityCountsSchema = z.object({
	queries: z.number().int().nonnegative(),
	vetting: z.number().int().nonnegative(),
})

export type ActivityCounts = z.output<typeof activityCountsSchema>

/**
 * How often an open screen re-asks for the counts; focus refetches too. There
 * is no push channel, so this is the longest a badge can lag behind an
 * Expert's reply. The count is one indexed query and a tiny response.
 */
export const ACTIVITY_REFETCH_MS = 15_000
